import {RegisterRoutesOptions} from '@/moduleSystem';

export const ROUTES__CORE = {
  BIG_TV: 'routes__core__big_tv',
  EVENT_GALLERY: 'routes__core__event_gallery',
  PHOTO_EVENT: 'routes__core__photo_event',
  SINGLE_PHOTO: 'routes__core__single_photo',
} as const;
export type ROUTES__CORE = Enum<typeof ROUTES__CORE>

export default [
  {
    name: ROUTES__CORE.BIG_TV,
    path: '/big-tv/:projectCode/:eventToken',
    component: () => import('./pages/BigTvPage.vue'),
  },
  {
    name: ROUTES__CORE.EVENT_GALLERY,
    path: '/event/:projectCode/:eventToken',
    component: () => import('./pages/PublicEventGalleryPage.vue'),
  },
  {
    name: ROUTES__CORE.PHOTO_EVENT,
    path: '/admin/event/:projectCode/:eventToken',
    component: () => import('./pages/AdminEventPage.vue'),
  },
  {
    name: ROUTES__CORE.SINGLE_PHOTO,
    path: '/photo/:projectCode/:eventToken/:sessionId',
    component: () => import('./pages/SinglePhotoPage.vue'),
  },
] as RegisterRoutesOptions;
